import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface PaginationControlsProps {
  onShowPrevious: () => void;
  onShowMore: () => void;
  disablePrevious: boolean;
  disableMore: boolean;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  onShowPrevious,
  onShowMore,
  disablePrevious,
  disableMore,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '80%',
      maxWidth: '600px',
      mt: 2,
      marginBottom: 0,
      paddingLeft: { xs: 2, sm: 4 },
      paddingRight: { xs: 3, sm: 12 },
    }}
  >
    {/* Left (Back) Arrow - aligned left */}
    <IconButton
      onClick={onShowPrevious}
      disabled={disablePrevious}
      sx={{
        color: '#000',
        border: '2px solid',
        borderColor: disablePrevious ? '#E5E5E5' : '#000',
        bgcolor: disablePrevious ? '#f5f5f5' : '#fff',
        p: 1.5,
        '&:hover': {
          bgcolor: '#f5f5f5',
          borderColor: disablePrevious ? '#E5E5E5' : '#000',
        },
        fontSize: 22,
      }}
    >
      <ArrowBackIosIcon sx={{ fontSize: 22, fontWeight: 710 }} />
    </IconButton>

    {/* 'past times' text just after the left arrow */}
    <Typography
      variant="body2"
      color="text.primary"
      sx={{
        fontSize: '0.90rem',
        fontWeight: 550,
        ml: 1, // margin left to separate from the arrow
        whiteSpace: 'nowrap',
        visibility: disablePrevious ? 'hidden' : 'visible',
      }}
    >
      past times
    </Typography>

    {/* Spacer to push content to the right */}
    <Box sx={{ flex: 1 }} />

    {/* 'more times' text just before the right arrow */}
    <Typography
      variant="body2"
      color="text.primary"
      sx={{
        fontSize: '0.90rem',
        fontWeight: 550,
        mr: 1, // margin right to separate from the arrow
        whiteSpace: 'nowrap',
        visibility: disableMore ? 'hidden' : 'visible',

      }}
    >
      more times
    </Typography>

    {/* Right (Forward) Arrow - aligned right */}
    <IconButton
      onClick={onShowMore}
      disabled={disableMore}
      sx={{
        color: '#000',
        border: '2px solid',
        borderColor: disableMore ? '#E5E5E5' : '#000',
        bgcolor: disableMore ? '#f5f5f5' : '#fff',
        p: 1.5,
        '&:hover': {
          bgcolor: '#f5f5f5',
          borderColor: disableMore ? '#E5E5E5' : '#000',
        },
        fontSize: 22,
      }}
    >
      <ArrowForwardIosIcon sx={{ fontSize: 22, fontWeight: 710 }} />
    </IconButton>
  </Box>
);

export default PaginationControls;